module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-image": "url('../../../static/assets/include/svg/svg-bg1.svg')",
      "background-attachment": "fixed"
    }
  }, [_c('div', {
    staticClass: "container registation_content g-pt-50 g-pb-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "g-max-width-645 text-center mx-auto g-mb-0"
  }, [_c('h2', {
    staticClass: "h2 mb-3"
  }, [_vm._v("Changing Life through Lenses® " + _vm._s(new Date().getFullYear()))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("Forecast Update")]), _vm._v(" "), _c('p', [_vm._v("\n             Please update your pledge/forecast for " + _vm._s(new Date().getFullYear()) + ". We understand it may\n             be difficult to predict how many you will serve. Please provide a\n             conservative estimate of how many charitable orders you anticipate\n             placing this year. Remember, you can change your forecast number\n             at any time on the My Account page.\n           ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('pledge', {
    attrs: {
      "Account": _vm.Account,
      "PledgeLabel": _vm.pledge,
      "PledgeHelpText": _vm.pledgeHelpText,
      "FormInputs": _vm.FormInputs,
      "OfficeLocationValidationResult": _vm.OfficeLocationValidationResult
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("End of Year Recap")]), _vm._v(" "), _c('p', [_vm._v("Please complete the following questions:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastServices),
      expression: "forecastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Serve walk ins and sporadic referrals in my office",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forecastServices) ? _vm._i(_vm.forecastServices, "Serve walk ins and sporadic referrals in my office") > -1 : (_vm.forecastServices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forecastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Serve walk ins and sporadic referrals in my office",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forecastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forecastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forecastServices = $$c
        }
      }
    }
  }), _vm._v("\n                 Serve walk ins and sporadic referrals in my office\n                 "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastServices),
      expression: "forecastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Host a vision event(s)",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forecastServices) ? _vm._i(_vm.forecastServices, "Host a vision event(s)") > -1 : (_vm.forecastServices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forecastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Host a vision event(s)",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forecastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forecastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forecastServices = $$c
        }
      }
    }
  }), _vm._v("\n                 Host a vision event(s)\n                 "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastServices),
      expression: "forecastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Partner with a local non profit or school to receive their referrals in my office",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forecastServices) ? _vm._i(_vm.forecastServices, "Partner with a local non profit or school to receive their referrals in my office") > -1 : (_vm.forecastServices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forecastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Partner with a local non profit or school to receive their referrals in my office",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forecastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forecastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forecastServices = $$c
        }
      }
    }
  }), _vm._v("\n                 Partner with a local non profit or school to receive their referrals in my office\n                 "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastServices),
      expression: "forecastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Volunteer at local clinics, health fairs, or vision events",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forecastServices) ? _vm._i(_vm.forecastServices, "Volunteer at local clinics, health fairs, or vision events") > -1 : (_vm.forecastServices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forecastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Volunteer at local clinics, health fairs, or vision events",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forecastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forecastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forecastServices = $$c
        }
      }
    }
  }), _vm._v("\n                 Volunteer at local clinics, health fairs, or vision events\n                 "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastServices),
      expression: "forecastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "I’m not sure",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forecastServices) ? _vm._i(_vm.forecastServices, "I’m not sure") > -1 : (_vm.forecastServices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forecastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "I’m not sure",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forecastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forecastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forecastServices = $$c
        }
      }
    }
  }), _vm._v("\n                   I’m not sure\n               ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('h5', [_vm._v("\n                   " + _vm._s(_vm.q1) + "\n                   ")]), _vm._v(" "), _c('p', [_vm._v("\n                   (Things to consider: Where, who, and when you served, did\n                   you find giving back had a positive impact for you or your\n                   organization)\n                 ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (1),
      expression: "1"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.UseCase),
      expression: "Account.UseCase"
    }],
    staticClass: "form-control no-arrow-updown",
    class: {
      error_field: false
    },
    attrs: {
      "type": "text",
      "minlength": "3",
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.Account.UseCase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "UseCase", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('h5', [_vm._v("\n                   " + _vm._s(_vm.q2) + "\n                   ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (1),
      expression: "1"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.FeedBack),
      expression: "Account.FeedBack"
    }],
    staticClass: "form-control no-arrow-updown",
    class: {
      error_field: false
    },
    attrs: {
      "type": "text",
      "minlength": "3",
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.Account.FeedBack)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "FeedBack", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toBeContactedAsVolunteer),
      expression: "toBeContactedAsVolunteer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.toBeContactedAsVolunteer) ? _vm._i(_vm.toBeContactedAsVolunteer, null) > -1 : (_vm.toBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.toBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toBeContactedAsVolunteer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toBeContactedAsVolunteer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toBeContactedAsVolunteer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_vm._v("I would like to be contacted if there are volunteer opportunities in my area.")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n             Thank you for all your hard work and for everything you do to help\n             those in need in your community!\n           ")]), _vm._v(" "), _c('p', [_vm._v("Together, we can keep Changing Life through Lenses.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "disabled": !(
        _vm.Account.PrimaryContact.OfficeLocation.NumberOfJobs > -1 &&
        (_vm.Account.UseCase.trim() != '' ? true : false)
      ),
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitForecast()
      }
    }
  }, [_vm._v("\n                 Submit\n               ")])])])])])])]), _vm._v(" "), (_vm.showForecastingModal) ? _c('annual-forecasting-modal') : _vm._e(), _vm._v(" "), (!_vm.isLoadFinish) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-xs-12 col-sm-12 g-pb-20"
  }, [_c('p', [_vm._v("\n                While you may experience ongoing effects\n                 of the pandemic, we want to ensure you have the resources to\n                 support the vision care of your whole community. Essilor\n                 Vision Foundation and Changing Life through Lenses (CLTL)\n                 stands as your partner to help you maintain and increase your\n                 charitable work to provide glasses to those most in need.\n               ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('h5', [_vm._v("\n                   How do you plan on serving those patients?\n                   ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('h5', [_vm._v("Update your Volunteer Engagement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for being a part of Changing Life through Lenses' (CLTL) extraordinary community of charitable eye doctors, practices and non-profits. Occasionally, we may become aware of volunteer opportunities available in your area, such as:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Volunteering at a regional clinic to conduct vision exams")]), _vm._v(" "), _c('li', [_vm._v("Connecting with a local nonprofit or school requesting vision services")]), _vm._v(" "), _c('li', [_vm._v("Supporting an individual patient inquiring with us about vision services in your area")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-388f7ba8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-388f7ba8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/AnnualForcasting.vue
// module id = 501
// module chunks = 4